import dayjs from 'dayjs';
import { parseOccSymbol } from '@tradingblock/api';

/**
 * For quote feed subscriptions: treat an option as no longer subscribable only when its
 * expiration *calendar date* is before today. Same-day expirations must stay subscribed
 * through the trading session (including PM index options until their product cutoff).
 *
 * (Previously, "expires today + market open" incorrectly filtered symbols — that removed
 * same-day options from subscriptions for the entire session.)
 */
export function isOptionPastCalendarExpirationDate(symbol: string): boolean {
  const symbData = parseOccSymbol(symbol);
  if (!symbData.expiration) {
    return false;
  }
  const expirationDate = dayjs(symbData.expiration).startOf('day');
  const today = dayjs().startOf('day');
  return expirationDate.isBefore(today);
}
